import React from 'react';
import { Instagram } from 'lucide-react';

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="py-16 md:py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <img
              src="https://customer-assets.emergentagent.com/job_instagram-growth-11/artifacts/79mhfl2d_Big%20Jaguar%20Logo.png"
              alt="Big Jaguar"
              className="h-20 md:h-28 w-auto mb-3"
              data-testid="footer-brand"
            />
            <p className="text-sm text-slate-400 leading-relaxed max-w-sm mb-6">
              Instagram growth systems for local businesses.
              We turn your profile into a customer acquisition machine.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/bigjaguar03/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10 transition-colors"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="md:col-span-3">
            <span className="font-accent text-slate-500 mb-4 block text-[11px]">
              Quick Links
            </span>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Services', href: '#services' },
                { label: 'Process', href: '#process' },
                { label: 'Results', href: '#results' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <button
                  key={link.href}
                  onClick={() => scrollTo(link.href)}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="text-sm text-slate-400 hover:text-white transition-colors text-left"
                >
                  {link.label}
                </button>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <span className="font-accent text-slate-500 mb-4 block text-[11px]">
              Get in Touch
            </span>
            <button
              onClick={() => scrollTo('#contact')}
              data-testid="footer-cta-button"
              className="bg-white text-slate-900 rounded-full px-6 py-3 text-sm font-medium hover:bg-slate-100 transition-colors inline-flex items-center gap-2"
            >
              Book a Free Strategy Call
            </button>
            <p className="text-xs text-slate-500 mt-4">
              Free audit. No commitment. Let's grow your business.
            </p>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500" data-testid="footer-copyright">
            &copy; {new Date().getFullYear()} Big Jaguar. All rights reserved.
          </p>
          <p className="text-xs text-slate-600">
            Instagram Growth Systems for Local Businesses
          </p>
        </div>
      </div>
    </footer>
  );
};
